import { createUseStyles } from "react-jss";
import { breakpoints } from "../../../constants/breakpoints";

const styles = createUseStyles({
  promoCodesModal: {
    width: "400px",
    marginTop: "17vh",
    "& .modal-content": {
      borderRadius: "12px",
      boxShadow: `0px 8px 8px -4px rgba(16, 24, 40, 0.03), 0px 20px 24px -4px rgba(16, 24, 40, 0.08);`,
    },
    "& .modal-header": {
      padding: "24px",
      "& button": {
        fontSize: "14px",
        position: "absolute",
        top: "31px",
        right: "31px"
      }
    },
    "& .modal-title": {
      padding: "0 24px"
    },
    "& .modal-body": {
      padding: "0px 24px 24px"
    },
    "& .modal-footer>*": {
      margin: "0px",
      padding: "8px 24px"
    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      width: "auto"
    }
  },
  modalDescription:{
    fontSize:"14px",
    marginTop: "8px",
  },
  promoCodesModalWrapper: {
    zIndex: "2001 !important",
  },
  promoCodesBackdrop: {
    zIndex: "2001 !important",
  },
});

export default styles;